export default __webpack_public_path__ + "static/media/logo.e7b3167b.svg";